import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import BidOffer from './BidOffer'
import ScheduleDetail from './ScheduleDetail'
import OpThreshold from './OpThreshold'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'
import OutageAnalyzer from './OutageAnalyzer'
import NetCapacityVerification from './verification/NetCapVerificationTest'
import VerificationHourly from './verification/MHourlyMWVerification'
import NetCapacityVerificationExport from './verification/NetCapVerifiactionExport'
import NetCapVerificationImport from './verification/NetCapVerificationImport'
import EventPending from './EventPending'
const PjmRouteContainer = ({ actionPermits, envConfig }) => {
  const hasBidOffer = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.BID_OFFER_READ,
          ScreenPermissions.BID_OFFER_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasScheduleDetail = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.SCHEDULE_DETAIL_READ,
          ScreenPermissions.SCHEDULE_DETAIL_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasOpThreshold = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.OP_THRESHOLD_READ,
          ScreenPermissions.OP_THRESHOLD_WRITE,
          ScreenPermissions.OP_THRESHOLD_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasOutageAnalyzer = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OUTAGE_ANALYZER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const netCapacityVerificationRead = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NET_CAP_VERIFICATION,
          ScreenPermissions.NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.NET_CAP_VERIFICATION_IMPORT,
          ScreenPermissions.NET_CAP_VERIFICATION_EXPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const netCapacityVerificationWrite = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NET_CAP_VERIFICATION_WRITE,
          //          ScreenPermissions.NET_CAP_VERIFICATION_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const netCapacityVerificationImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NET_CAP_VERIFICATION_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const netCapacityVerificationExport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NET_CAP_VERIFICATION_EXPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const VerificationHourlyMWH = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VERIFICATION_HOURLY_MWH],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const eventPending = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.VALIDATION_EVENT_PENDING,
          ScreenPermissions.VALIDATION_EVENT_PENDING_APPROVAL,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {eventPending && (
        <Route exact path="/event-pending" component={EventPending} />
      )}
      {hasBidOffer && <Route exact path="/oa-bid-offer" component={BidOffer} />}
      {hasScheduleDetail && (
        <Route exact path="/oa-schedule-details" component={ScheduleDetail} />
      )}
      {hasOpThreshold && (
        <Route exact path="/op-rsv-threshold" component={OpThreshold} />
      )}
      {hasOutageAnalyzer && (
        <Route exact path="/outage-analyzer" component={OutageAnalyzer} />
      )}
      {(netCapacityVerificationWrite || netCapacityVerificationRead) && (
        <Route
          exact
          path="/net-cap-verification"
          component={NetCapacityVerification}
        />
      )}
      {VerificationHourlyMWH && (
        <Route
          exact
          path="/verification-hourly-mwh"
          component={VerificationHourly}
        />
      )}
      {netCapacityVerificationExport && (
        <Route
          exact
          path="/net-cap-verification-data-export"
          component={NetCapacityVerificationExport}
        />
      )}
      {netCapacityVerificationImport && (
        <Route
          exact
          path="/net-cap-verification-data-import"
          component={NetCapVerificationImport}
        />
      )}
    </React.Fragment>
  )
}

export { PjmRouteContainer }
